import React from 'react';
import AdtopiaLoadRoot from '../../Utility/AdtopiaLoadRoot';

const HomePage = () => {
  const renderSplitName = () => {
  }
  return (
    <>
      <AdtopiaLoadRoot pageType="home" renderSplitName={renderSplitName} splitName="/BMC_V1" />
    </>
  )
}

export default HomePage;